import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CreditStatementsDialogContentComponent } from './credit-statements-dialog-content/credit-statements-dialog-content.component';

@Component({
  selector: 'credit-statements-dialog',
  template: ''
})
export class CreditStatementsDialogComponent implements OnDestroy {
  
  private modal: NgbModalRef | null = null

  constructor(
    public modalService: NgbModal,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngAfterViewInit() {
    if (this.modalService.hasOpenModals()) return
    this.openDialog();
  }

  openDialog(): void {
    if (this.modal) {
      this.modal.close()
    }

    this.modal = this.modalService.open(
      CreditStatementsDialogContentComponent,
      { centered: true, backdrop: 'static', size: 'xl' }
    )

    this.modal.result.then((result) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute })
    }, (reason) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute })
    })
  }

  ngOnDestroy() {
    if (this.modal) {
      this.modal.close()
    }
  }
}
